import React, { useState } from "react";
import izziLogo from "../assets/images/izziTelecomLogo.png";
import styles from "../styles/Login.module.scss";
import axios from "axios";
import genericLogo from "../assets/images/generic_logo2.png";
import toast from "react-hot-toast";
import { Eye, EyeOff } from "lucide-react";
import integratelLogo from "../assets/images/integratelLogo6.png";

type LoginProps = {
	checkWhenLogged: (logged: boolean) => void;
};

const Login = ({ checkWhenLogged }: LoginProps) => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const apiUrl = process.env.REACT_APP_AUTH;
	const [showPassword, setShowPassword] = useState(false);

	const handleLogin = async (e: React.FormEvent) => {
		e.preventDefault();
		setLoading(true);
		setError(null);

		try {
			// Ensure the URL exists
			if (!apiUrl) {
				throw new Error("Auth URL is not defined in environment variables");
			}

			const response = await axios.post(`${apiUrl}/login`, {
				email_address: email.trim(),
				password: password.trim(),
			});

			toast.success("¡Bienvenido!");
			sessionStorage.setItem("userData", JSON.stringify(response.data));

			checkWhenLogged(true);
		} catch (err: any) {
			console.error("Login Error:", err);
			toast.error("Ha ocurrido un error");
			setError(err.response?.data?.message || "An error occurred during login");
		} finally {
			setLoading(false);
			const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
			console.log(userData);
		}
	};

	return (
		<div className="min-vh-100 d-flex align-items-center justify-content-center bg-light p-3">
			<div className="w-100" style={{ maxWidth: "450px" }}>
				<div className="card border-0 shadow-lg overflow-hidden">
					{/* Top Multi-color Accent Bar */}
					{/* <div className={`${styles["accent-bar"]}`}>
						<div className="flex-grow-1" style={{ backgroundColor: "var(--operador-teal)" }}></div>
					</div> */}

					<div className="card-body p-4 p-md-5" style={{ backgroundColor: "#021928" }}>
						{/* Logo Header */}
						<div className="text-center mb-4">
							<img src={integratelLogo} alt="Izzi Logo" className="img-fluid mb-2" style={{ width: "360px" }} />
						</div>

						{/* Login Form */}
						<form onSubmit={handleLogin}>
							<div className="mb-3">
								<label className="form-label small fw-bold text-secondary w-100 text-start">Correo Electrónico</label>
								<input
									type="email"
									name="email"
									className={`form-control-lg fs-6 form-control ${styles["form-control"]}`}
									placeholder="nombre@ejemplo.com"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									required
								/>
							</div>

							<div className="mb-4">
								<div className="d-flex justify-content-between">
									<label className="form-label small fw-bold text-secondary">Contraseña</label>
									{/* <a href="#" className={`text-decoration-none small fw-bold ${styles["text-izzi-teal"]}`}>
										¿Has olvidado tu contraseña?
									</a> */}
								</div>
								<div style={{ position: "relative" }}>
									<input
										type={showPassword ? "text" : "password"}
										className="form-control form-control-lg"
										placeholder="••••••••"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										required
										style={{ paddingRight: "45px" }} // Make space for the icon
									/>
									<button
										type="button"
										onClick={() => setShowPassword(!showPassword)}
										style={{
											position: "absolute",
											right: "10px",
											top: "50%",
											transform: "translateY(-50%)",
											background: "transparent",
											border: "none",
											cursor: "pointer",
											padding: "5px",
											display: "flex",
											alignItems: "center",
											color: "#6c757d",
										}}>
										{showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
									</button>
								</div>
							</div>

							<div className="d-grid">
								<button disabled={loading} type="submit" className={`btn btn-lg ${styles["btn-izzi-dark"]}`}>
									{loading ? (
										<>
											<span className="spinner-border spinner-border-sm me-2 text-light" role="status" aria-hidden="true"></span>
											<p className=" text-light d-inline">Cargando...</p>
										</>
									) : (
										"Login"
									)}
								</button>
							</div>
						</form>

						{/* Footer */}
						{/* <div className="mt-5 pt-4 border-top text-center">
							<p className="small text-light">
								¿No tienes una cuenta?{" "}
								<a href="s" className={`text-decoration-none fw-bold `}>
									Regístrate ahora
								</a>
							</p>
						</div> */}
					</div>
				</div>

				{/* Legal Footer */}
				<div className="mt-4 text-center text-muted" style={{ fontSize: "0.75rem" }}>
					<p className="mb-1">© {new Date().getFullYear()} Newtoms. Todos los derechos reservados.</p>
					<div>
						<span className="text-muted text-decoration-none me-3">Política de Privacidad</span>
						<span className="text-muted text-decoration-none">Términos de servicio</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
